import React, { memo } from 'react';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';

export function ProductionResponsibles({ responsibles }) {
    if (!responsibles || !responsibles.length) {
        return <span>Sorumlu Yok</span>;
    }

    // Display up to 3 avatars, with a +X indicator if there are more
    const visibleResponsibles = responsibles.slice(0, 3);
    const remainingCount = responsibles.length - visibleResponsibles.length;

    return (
        <Stack direction="row" spacing={-1}>
            {visibleResponsibles.map((user) => (
                <Tooltip key={user._id} title={user.username || ''} placement="top">
                    <Avatar
                        alt={user.username || ''}
                        src={user.profilePicture || ''}
                        sx={{ width: 30, height: 30, border: '2px solid #fff' }}
                    >
                        {!user.profilePicture && (user.username ? user.username.charAt(0).toUpperCase() : 'U')}
                    </Avatar>
                </Tooltip>
            ))}
            {remainingCount > 0 && (
                <Tooltip
                    title={responsibles
                        .slice(3)
                        .map((u) => u.username)
                        .join(', ')}
                    placement="top"
                >
                    <Box
                        sx={{
                            width: 30,
                            height: 30,
                            backgroundColor: '#f5f5f5',
                            color: '#666',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '2px solid #fff',
                            fontSize: '0.75rem',
                            fontWeight: 'bold',
                        }}
                    >
                        +{remainingCount}
                    </Box>
                </Tooltip>
            )}
        </Stack>
    );
}

export default memo(ProductionResponsibles);
